"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _R37KOEUWcjs = require('../__chunks/R37KOEUW.cjs');
require('../__chunks/75F3RDBE.cjs');


var _UGAVMSQJcjs = require('../__chunks/UGAVMSQJ.cjs');
require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/CVLMIMPT.cjs');
require('../__chunks/2RUCRSRF.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');








var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');



var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/menu/menu-store.ts
function createMenuStore({
  combobox,
  parent,
  menubar,
  ...props
} = {}) {
  const parentIsMenubar = !!menubar && !parent;
  const store = _WMTGHDLEcjs.mergeStore.call(void 0, 
    props.store,
    _WMTGHDLEcjs.pick.call(void 0, parent, ["values"]),
    _WMTGHDLEcjs.omit.call(void 0, combobox, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  _WMTGHDLEcjs.throwOnConflictingProps.call(void 0, props, store);
  const syncState = store.getState();
  const composite = _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    store,
    orientation: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.orientation,
      syncState.orientation,
      "vertical"
    )
  });
  const hovercard = _R37KOEUWcjs.createHovercardStore.call(void 0, {
    ...props,
    store,
    placement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.placement,
      syncState.placement,
      "bottom-start"
    ),
    timeout: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.timeout,
      syncState.timeout,
      parentIsMenubar ? 0 : 150
    ),
    hideTimeout: _4TRESXTOcjs.defaultValue.call(void 0, props.hideTimeout, syncState.hideTimeout, 0)
  });
  const initialState = {
    ...composite.getState(),
    ...hovercard.getState(),
    initialFocus: _4TRESXTOcjs.defaultValue.call(void 0, syncState.initialFocus, "container"),
    values: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.values,
      syncState.values,
      props.defaultValues,
      {}
    )
  };
  const menu = _WMTGHDLEcjs.createStore.call(void 0, initialState, composite, hovercard, store);
  _WMTGHDLEcjs.setup.call(void 0, 
    menu,
    () => _WMTGHDLEcjs.sync.call(void 0, menu, ["mounted"], (state) => {
      if (state.mounted) return;
      menu.setState("activeId", null);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    menu,
    () => _WMTGHDLEcjs.sync.call(void 0, parent, ["orientation"], (state) => {
      menu.setState(
        "placement",
        state.orientation === "vertical" ? "right-start" : "bottom-start"
      );
    })
  );
  return {
    ...composite,
    ...hovercard,
    ...menu,
    combobox,
    parent,
    menubar,
    hideAll: () => {
      hovercard.hide();
      parent == null ? void 0 : parent.hideAll();
    },
    setInitialFocus: (value) => menu.setState("initialFocus", value),
    setValues: (values) => menu.setState("values", values),
    setValue: (name, value) => {
      if (name === "__proto__") return;
      if (name === "constructor") return;
      if (Array.isArray(name)) return;
      menu.setState("values", (values) => {
        const prevValue = values[name];
        const nextValue = _4TRESXTOcjs.applyState.call(void 0, value, prevValue);
        if (nextValue === prevValue) return values;
        return {
          ...values,
          [name]: nextValue !== void 0 && nextValue
        };
      });
    }
  };
}


exports.createMenuStore = createMenuStore;
